import React from 'react';
import { Container } from 'react-bootstrap';
import { MisCursosExternosList } from '../../../common/cursosExternos';

export default function MisCursosExternos() {
  return (
    <Container fluid className="p-4">
      <h3>Cursos Externos</h3>
      <MisCursosExternosList />
    </Container>
  );
}
